import React, {Component} from "react";
import {Form, Errors, Control} from "react-redux-form";
import {required} from "../field_validations";
import {toInt} from "../parsers";
import _ from "lodash";
import {confirmAlert} from "react-confirm-alert";

export default class RegisterEmail extends Component{
	render(){
		const {register} = this.props;
		let listData = !_.isEmpty(register.data) && register.data.modality_id ? _.find(register.modalities, {id: register.data.modality_id}):undefined;
		let roleList = listData ? listData.roles:[];
		let statesList = listData ? listData.states:[];
		let stateData = listData && listData.id === 2 && register.data.state_id ? _.find(statesList, {id: register.data.state_id }):undefined;
		let municipalitiesList = stateData ? stateData.municipalities:[];
		return (
			<div className="content">
				<p className="is-size-5 has-text-left">Registro de instancia</p>

				{register.error && <p className="has-text-centered help is-danger">{register.error}</p>}
				{register.message && <p className="has-text-centered help is-success">{register.message}</p>}

				<Form model='register.data' onSubmit={(val) => this._handleSubmit(val)}
				      onSubmitFailed={(error) => {console.log('error', error)}}>
					<div className="field is-grouped">
						<div className="control is-expanded">
							<label htmlFor="name" className="label">Nombre: <small className="has-text-grey">{`${register.data.name} ${register.data.last_name} ${register.data.slast_name}`}</small></label>
						</div>

						<div className="control">
							<label htmlFor="email" className="label">Email: <small className="has-text-grey">{register.data.email}</small></label>
						</div>
					</div>

					<div className="field is-grouped">
						<div className="control">
							<label htmlFor="modality_id" className="label">Modalidad <span className="small has-text-danger">*</span></label>
							<div className="select">
								<Control.select model=".modality_id" id="modality_id" changeAction={(model,value) => this._changeMod(model,value)} errors={{required}} validateOn="change">
									<option value={0} defaultValue>--- Modalidad ---</option>
									{_.map(register.modalities,(option, k) => {
										return <option value={option.id} key={k}>{option.name}</option>
									})}
								</Control.select>
							</div>
							<Errors model=".modality_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes seleccionar una modalidad.' }} />
						</div>

						{listData ?
						<div className="control is-expanded">
							<label htmlFor="roles" className="label">Perfil <span className="small has-text-danger">*</span></label>
							<div className="select">
								<Control.select id="roles" model=".role_id" errors={{required}} parser={ toInt } validateOn="change">
									<option value="" defaultValue>--- Perfil ---</option>
									{_.map(roleList, (row, k) => {
										return (
											<option key={k} value={row.id}>{row.display ? row.display : row.name}</option>
										)
									})}
								</Control.select>
							</div>
							<Errors model=".role_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El perfil es obligatorio'}} />
						</div>:''}
					</div>

					<div className="field is-grouped">
						{listData ?
						<div className="control is-expanded">
							<label htmlFor="state_id" className="label">Instancia <span className="small has-text-danger">*</span></label>
							<div className="select">
								<Control.select id="state_id" model=".state_id" errors={{required}} parser={ toInt } validateOn="change">
									<option value="" defaultValue>--- Instancia ---</option>
									{_.map(statesList, (row, k) => {
										return (
											<option key={k} value={row.id}>{row.name}</option>
										)
									})}
								</Control.select>
							</div>
							<Errors model=".state_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'La instancia es obligatoria'}} />
						</div>:''}

						{stateData ?
						<div className="control is-expanded">
							<label htmlFor="municipality_id" className="label">Municipio <span className="small has-text-danger">*</span></label>
							<div className="select">
								<Control.select id="municipality_id" model=".municipality_id" errors={{required}} parser={ toInt } validateOn="change">
									<option value="" defaultValue>--- Municipio ---</option>
									{_.map(municipalitiesList, (row, k) => {
										return (
											<option key={k} value={row.id}>{row.name}</option>
										)
									})}
								</Control.select>
							</div>
							<Errors model=".municipality_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El municipio es obligatorio'}} />
						</div>:''}
					</div>


					<div className="level">
						<div className="level-left">
							<div className="level-item">
								<button onClick={() => this.props.reset()} className="button">Regresar</button>
							</div>
						</div>
						<div className="level-right">
							<div className="level-item">
								<Control.button model="register.data" className="button is-black">
									<span>Registrar</span>
								</Control.button>
							</div>
						</div>
					</div>
				</Form>
			</div>
		)
	}

	_handleSubmit(values) {
		this.props.registerEmail(values);
		//console.log('values===>', values);
	}

	_changeMod(model,value){
		if(value === '1' || value === '3'){
			this._getConfirm(model,_.toNumber(value));
		}else {
			this.props.change(model,_.toNumber(value));
		}
	}

	_getConfirm(model, value){
		confirmAlert({
			title: '¿Está seguro/segura?',
			message: `¿Estas seguro/segura de ser titular de IMEF?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.change(model,value),
			onCancel: () => this.props.change('register.data.modality_id', '')
		})
	}
}


// WEBPACK FOOTER //
// ./src/elements/register/registerEmail.jsx